import { render, staticRenderFns } from "./UsersContainer.vue?vue&type=template&id=5d52d9f4&scoped=true&"
import script from "./UsersContainer.vue?vue&type=script&lang=js&"
export * from "./UsersContainer.vue?vue&type=script&lang=js&"
import style0 from "./UsersContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UsersContainer.vue?vue&type=style&index=1&id=5d52d9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d52d9f4",
  null
  
)

export default component.exports